import { render, staticRenderFns } from "./LanguageFlag.vue?vue&type=template&id=02acc351&scoped=true&"
import script from "./LanguageFlag.vue?vue&type=script&lang=js&"
export * from "./LanguageFlag.vue?vue&type=script&lang=js&"
import style0 from "./LanguageFlag.vue?vue&type=style&index=0&id=02acc351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02acc351",
  null
  
)

export default component.exports